import { SET_VEHICLE_ID } from '../actions/types';

export default function vehicleId(state = '', action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_VEHICLE_ID:
				return action.payload;
			default:
				return state;
		}
	}

	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/vehicleId.js